import { ref, computed } from 'vue';
import { defineStore } from 'pinia';

export const useOrderStore = defineStore('order', () => {
	const cart = ref([]);
	const tips = ref(0);
	const orderId = ref('')

	function addProduct(product, selectedModifiers = []) {
		const sortedModifiers = [...selectedModifiers].sort((a, b) => a.id - b.id);
		const modifiersIds = sortedModifiers.map(m => m.id).join('_');
		const productOrderIndex = `${product.id}_${modifiersIds}`;

		const item = cart.value.find(i => i.product_order_index === productOrderIndex);

		if (item) {
			item.amount++;
		} else {
			cart.value.push({
				...product,
				amount: 1,
				modifiers: sortedModifiers.filter(m => m.type === 'modifier'),
				notes: sortedModifiers.filter(m => m.type === 'ingredient'),
				product_order_index: productOrderIndex
			});
		}
	}


	function removeProduct(product, selectedModifiers = []) {
		const sortedModifiers = [...selectedModifiers].sort((a, b) => a.id - b.id);
		const modifiersIds = sortedModifiers.map(m => m.id).join('_');
		const productOrderIndex = `${product.id}_${modifiersIds}`;

		const itemIndex = cart.value.findIndex(i => i.product_order_index === productOrderIndex);

		if (itemIndex !== -1) {
			if (cart.value[itemIndex].amount > 1) {
				cart.value[itemIndex].amount--;
			} else {
				cart.value.splice(itemIndex, 1);
			}
		}
	}

	function removeAllByProductId(productId) {
		cart.value = cart.value.filter(i => i.product_order_index !== productId);
	}

	function clearCart() {
		cart.value = [];
		tips.value = 0;
	}

	function getAmount(productOrderIndex) {
		const item = cart.value.find(i => i.product_order_index === productOrderIndex);
		return item ? item.amount : 0;
	}

	function generateOrderId() {
		const now = new Date()
		const year = now.getFullYear()
		const month = String(now.getMonth() + 1).padStart(2, '0')
		const day = String(now.getDate()).padStart(2, '0')
		const hours = String(now.getHours()).padStart(2, '0')
		const minutes = String(now.getMinutes()).padStart(2, '0')
		const seconds = String(now.getSeconds()).padStart(2, '0')
		const milliseconds = String(now.getMilliseconds()).padStart(3, '0')

		orderId.value = `${year}${month}${day}${hours}${minutes}${seconds}${milliseconds}`
	}

	function resetOrderId() {
		orderId.value = ''
	}

	const subtotal = computed(() => {
		return cart.value.reduce((sum, item) => {
			const basePrice = Number(item.price) * item.amount;

			const notesPrice = (item.notes || []).reduce((notesSum, note) => {
				return notesSum + (Number(note.inMenuPrice || 0) * item.amount);
			}, 0);

			const modifiersPrice = (item.modifiers || []).reduce((modSum, mod) => {
				return modSum + (Number(mod.price || 0) * item.amount);
			}, 0);

			return sum + basePrice + notesPrice + modifiersPrice;
		}, 0);
	});

	const tipsAmount = computed(() => {
		return Math.round(+(subtotal.value * (tips.value / 100)));
	});

	const total = computed(() => {
		return Number(subtotal.value);

		// return Number(subtotal.value + tipsAmount.value);
	});


	return {
		cart,
		tips,
		total,
		subtotal,
		orderId,
		tipsAmount,
		generateOrderId,
		resetOrderId,
		addProduct,
		removeProduct,
		removeAllByProductId,
		clearCart,
		getAmount,
	};
});
